"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
require("@ui-propulsion/toolkit");
require("./styles.scss");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactComponents = require("@ui-propulsion/react-components");
var _sharedComponents = require("@pf-loan-funnel/shared-components");
var _components = require("./components");
var _constants = require("./utils/constants");
var _utils = require("./utils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Refunds = function Refunds(_ref) {
  var disbursement = _ref.disbursement,
    previousRefundsTotal = _ref.previousRefundsTotal,
    contacts = _ref.contacts,
    application = _ref.application,
    refunds = _ref.refunds,
    isAgent = _ref.isAgent,
    applicationId = _ref.applicationId,
    clientId = _ref.clientId,
    actionsUrls = _ref.actionsUrls,
    draftRefund = _ref.draftRefund,
    goToDashboard = _ref.goToDashboard;
  /**
   * Possible states on refund flow:
   * - INITIAL: create a new refund
   * - DRAFT: load a previously saved refund
   * - SUBMITTED: submitted refund
   * - ERROR: error in submission process
   * - FULL : credit remaning is 0 or less
   */
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    refundStatus = _useState2[0],
    setRefundStatus = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    submittedData = _useState4[0],
    setSubmittedData = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    inProgress = _useState6[0],
    setInProgress = _useState6[1];
  var initializeRefundStatus = function initializeRefundStatus() {
    if (draftRefund) {
      setRefundStatus(_constants.refundDraftStatus);
    } else if (parseFloat(previousRefundsTotal) === parseFloat(disbursement.amountFinanced)) {
      setRefundStatus(_constants.refundFullStatus);
    } else {
      setRefundStatus(_constants.refundInitialStatus);
    }
  };
  (0, _react.useEffect)(function () {
    initializeRefundStatus();
  }, []);
  if (!refundStatus) return null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_sharedComponents.Spinner, {
    show: inProgress
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "page__container"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true,
    justifyContent: "space-between",
    align: "center",
    direction: "row",
    wrap: "nowrap"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "page__title"
  }, "Refund")), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Button, {
    className: "btn-close",
    "aria-label": "Go to dashboard",
    variant: "tertiary",
    onClick: goToDashboard,
    "data-test-id": "close-icon"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "icon-close"
  })))), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true,
    spacing: 4,
    className: "refund__container"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 12,
    md: 5
  }, /*#__PURE__*/_react.default.createElement(_components.ApplicationInfo, application), /*#__PURE__*/_react.default.createElement(_components.DisbursementInfo, disbursement), /*#__PURE__*/_react.default.createElement(_components.RefundsHistory, {
    refunds: refunds
  })), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    md: 1
  }), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 12,
    md: 6,
    className: "refund-confirmation"
  }, refundStatus !== _constants.refundInitialStatus && refundStatus !== _constants.refundDraftStatus ? /*#__PURE__*/_react.default.createElement(_components.RefundNotification, {
    hasError: refundStatus === _constants.refundErrorStatus,
    isAgent: isAgent,
    isDraftSaved: submittedData === null || submittedData === void 0 ? void 0 : submittedData.save,
    isDraftDeleted: submittedData === null || submittedData === void 0 ? void 0 : submittedData.delete,
    isFullRefund: refundStatus === _constants.refundFullStatus,
    dateProcessed: submittedData === null || submittedData === void 0 ? void 0 : submittedData.dateProcessed,
    refundAmount: submittedData === null || submittedData === void 0 ? void 0 : submittedData.netRefund,
    creditRemaining: submittedData === null || submittedData === void 0 ? void 0 : submittedData.refundAmount,
    goToDashboard: goToDashboard
  }) : /*#__PURE__*/_react.default.createElement(_components.RefundInstructionForm, {
    applicationId: applicationId,
    clientId: clientId,
    actionsUrls: actionsUrls,
    disbursedAmount: disbursement.amountFinanced,
    previousRefundsTotal: previousRefundsTotal,
    feeRate: disbursement.feeRate,
    isAgent: isAgent,
    draftRefund: draftRefund,
    contacts: contacts,
    setRefundStatus: setRefundStatus,
    setSubmittedData: setSubmittedData,
    setInProgress: setInProgress,
    goToDashboard: goToDashboard,
    netPracticeFee: disbursement.netPracticeFee
  })))));
};
Refunds.defaultProps = {
  refunds: [],
  contacts: [],
  isAgent: false,
  draftRefund: null,
  goToDashboard: _utils.goToDashboardLCPS
};
Refunds.propTypes = {
  application: (0, _propTypes.shape)({
    firstName: _propTypes.string.isRequired,
    lastName: _propTypes.string.isRequired,
    mailingAddress1: _propTypes.string.isRequired,
    mailingAddressCity: _propTypes.string.isRequired,
    mailingAddressState: _propTypes.string.isRequired,
    mailingAddressZip: _propTypes.string.isRequired,
    homePhone: _propTypes.string.isRequired
  }).isRequired,
  disbursement: (0, _propTypes.shape)({
    disbursementDate: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    disbursedAmount: _propTypes.string.isRequired,
    feeRate: _propTypes.number.isRequired,
    netPracticeFee: _propTypes.string.isRequired,
    caseSizeSavings: _propTypes.number.isRequired
  }).isRequired,
  refunds: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    applicationId: _propTypes.number.isRequired,
    clientId: _propTypes.number.isRequired,
    refundId: _propTypes.number,
    dateProcessed: _propTypes.string,
    refundAmount: _propTypes.string.isRequired
  })),
  contacts: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.number.isRequired,
    value: _propTypes.number.isRequired,
    label: _propTypes.string.isRequired
  })),
  previousRefundsTotal: _propTypes.number.isRequired,
  isAgent: _propTypes.bool,
  draftRefund: (0, _propTypes.shape)({
    applicationId: _propTypes.number.isRequired,
    clientId: _propTypes.number.isRequired,
    refundId: _propTypes.number.isRequired,
    dateProcessed: _propTypes.string,
    refundAmount: _propTypes.string.isRequired
  }),
  applicationId: _propTypes.number.isRequired,
  clientId: _propTypes.number.isRequired,
  actionsUrls: (0, _propTypes.shape)({
    post: (0, _propTypes.shape)({
      url: _propTypes.string.isRequired,
      method: _propTypes.string.isRequired
    }).isRequired,
    delete: (0, _propTypes.shape)({
      url: _propTypes.string.isRequired,
      method: _propTypes.string.isRequired
    }),
    patch: (0, _propTypes.shape)({
      url: _propTypes.string.isRequired,
      method: _propTypes.string.isRequired
    }).isRequired
  }).isRequired,
  goToDashboard: _propTypes.func
};
var _default = Refunds;
exports.default = _default;
